<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>
              <span>Unidad de negocios que usan el concepto pago: </span>
              <span> {{ nameconcepto }}</span>
            </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14" class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Asignar otra Unidad
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.unidad_negocio`]="{ item }">
          <p class="mb-0">({{ item.unidad_negocio.id }}) {{ item.unidad_negocio.nombre }}</p>
        </template>
        <template v-slot:[`item.nit`]="{ item }">
          <p class="mb-0"> {{ item.nit ? item.nit.nro:'?' }} </p>
        </template>
        <template v-slot:[`item.cuenta_netsuite`]="{ item }">
          <p class="mb-0"> {{ item.cuenta_netsuite ? item.cuenta_netsuite.numero:'' }} </p>
        </template>
        <!-- <template v-slot:[`item.codigo_sin`]="{ item }">
          <p class="mb-0"> {{ item.concepto_pago.codigo_sin }}</p>
        </template>
        <template v-slot:[`item.codigo_actividad`]="{ item }">
          <p class="mb-0"> {{ item.concepto_pago.codigo_actividad }}</p>
        </template> -->
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2" small color="red" v-bind="attrs" v-on="on" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span> Editar </span>
          </v-tooltip>

          <v-tooltip bottom v-if="$store.state.CARGO.id == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2" small color="red" v-bind="attrs" v-on="on" @click="predesasignar(item)">
                mdi-delete
              </v-icon>
            </template>
            <span> Quitar de esta unidad </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>

    <AsignarUnidad ref="asignarunidad" v-on:onsave="onsave" />
  </div>
</template>

<script>
  import AsignarUnidad from '@/views/conceptos/asignarunidad.vue';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      nameconcepto: '',
      headers: [
        { text: '#', value: 'nro' },
        { text: 'Unidad Negocio', value: 'unidad_negocio' },
        { text: 'Cuenta contable', value: 'cuenta_contable' },
        { text: 'Netsuite', value: 'cuenta_netsuite' },
        { text: 'Descripcion cuenta contable', value: 'descripcion_cuenta_contable' },
        // { text: 'codigo sin', value: 'codigo_sin' },
        { text: 'codigo actividad', value: 'actividad_economica_sin' },
        { text: 'nit', value: 'nit' },
        { text: 'Opciones', value: 'actions', width: 100 },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),
    components: { AsignarUnidad },
    methods: {
      editItem(item) {
        //window.console.log('Editar concepto pago:', item);
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialog = true;
        this.$refs.asignarunidad.openmodal(item);
      },
      verporunidades() {},
      onsave() {
        this.getconceptos();
      },

      getconceptos() {
        this.nameconcepto = this.$route.query.name;
        let idconcepto = this.$route.query.idconcepto;
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        let vue = this;
        vue.loading = true;
        var config = {
          method: 'get',
          // url: `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/conceptopago/${idconcepto}/unidadnegocio/${unidad}`,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio?concepto_pago=${idconcepto}`,
          headers: {
            'Content-Type': 'application/json',
            // 'unidad_negocio_id': unidad
          },
          
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            // data.map((p)=>{p.netsuite = p.cuenta_netsuite;})

            window.console.log('getconceptosunidad>>>', data, unidad);
            if (typeof(data) == 'object' && data.agrupador){
              data.unidad_negocio = {};
              vue.desserts = [data];
            }else{
              data.map((c, ind) => {
              c.nro = ind + 1;
            });
            vue.desserts = data;
            }
            
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      predesasignar(item) {
        window.console.log('item>>>>',item);
        let vue = this;
        let opt = {
          verification: 'quitar',
          verificationHelp: 'Escriba "[+:verification]" para quitar de la unidad.',
          okText: 'Quitar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'hard',
        };
        var message = {
          title: 'Confirmar eliminacion.',
          body: '<br> <b>NOTA:</b> Esta accion es irreversible.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.quitarunidad(item, dialog);
          })
          .catch(function() {});
      },
      quitarunidad(item, dialog) {
        dialog.close();

        let vue = this;
        var config = {
          method: 'delete', 
          //   `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/conceptopago/${item.concepto_pago_id}/unidadnegocio/${item.unidad_negocio_id}/nit/{NITID:[1-9][0-9]{0,8}}`
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/conceptopago/${item.concepto_pago_id}/unidadnegocio/${item.unidad_negocio_id}/nit/${item.nit_id}`,
          headers: {
            'Content-Type': 'application/json',
            //apikey: '4265269017',
          },
          //data: {},
        };

        xaxios.request(config)
          .then(function(response) {
            window.console.log(response.data.data);
            dialog.close();
            vue.$root.$notify.show('Ok', { color: 'success' });
            vue.getconceptos();
          })
          .catch(function(error) {
            window.console.log(error.response);
            dialog.close();
            vue.$root.$notify.show('No se pudo eliminar', { color: 'red' });
          });
      },
      
    },
    mounted() {
      this.getconceptos();
    },
  };
</script>
